var JobModel = BaseObjectModel.extend({
  className: "JobModel",

  // Загрузка событий блока ТМ-а
  loadEvents: function (standardRouteEvents) {
    var me = this;
    var currentStandardRouteEvents = standardRouteEvents[this.LeadTaskStandartRouteCode];
    // Найдем нужный объект (для текущего ТМ-а).
    if (typeof currentStandardRouteEvents != 'undefined') {
      // ... и только для конкретного блока. Если подходящего (по ИД) нет, то не биндим.
      if (typeof currentStandardRouteEvents.blocks[this.WorkflowBlockID] != 'undefined') {
        $.each(currentStandardRouteEvents.blocks[this.WorkflowBlockID], function (eventName, eventCallback) {
          me.bind(eventName, eventCallback);
        });
      }
    }
  },
  //Установка метода,который вызывается для всех заданий по ТМ перед запросом параметров
  bindBeforeAskingCommonEvent: function (commonEvent) {
    var me = this;
    if($.isFunction(commonEvent)) {
      me.bind('BeforeParamAsking', commonEvent);
    }
  },
  //Выполнение задания с результатом выполнения
  performResult: function (performResult) {
    Core.toolBars.job.performResult(performResult);
  }
});

/**
* Тип задания.
* @enum {integer} JOB_KIND
* @readonly
* @global
*/
var JOB_KIND = {
  /** Задача */
  JOB: 0,
  /** Уведомление  */
  NOTICE: 1,
  /** Задание-контроль */
  CONTROLJOB: 2
};